import { HTTP_INTERCEPTORS } from '@angular/common/http';

import { ConfirmationTokenInterceptor } from './confirmation-token/confirmation-token.interceptor';

export const HttpInterceptorProviders = [
	{ provide: HTTP_INTERCEPTORS, useClass: ConfirmationTokenInterceptor, multi: true }
];

export { setConfirmationToken } from './confirmation-token/confirmation-token.interceptor';
